<template>
  <div class="ui-empty" :class="`hook-${hook} layout-${layout}`">
    <div class="empty-box">
      <div class="icon"></div>
      <p v-if="!loading">{{ tip }}</p>
      <p v-else>{{ loadingTip }}</p>
    </div>
    <slot></slot>
  </div>
</template>

<script setup>
defineOptions({ name: 'UiEmpty' })

defineProps({
  tip: {
    type: String,
    default: '敬请期待！'
  },
  hook: {
    type: String,
    default: 'vh'
  },
  layout: {
    type: String,
    default: 'row'
  },
  loading: {
    type: Boolean,
    default: false
  },
  loadingTip: {
    type: String,
    default: 'loading...'
  }
})
</script>

<style lang="scss" scoped>
.ui-empty {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .empty-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon {
        background-image: url('https://website.xdcdn.net/poster/58881/20250717/K833xbCX.png');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
    p {
        text-align: center;
        color: #000;
        opacity: 0.5;
    }
  }

  &.layout-column {
    .empty-box {
      width: 80%;
    }
    .icon {
      width: 100%;
      padding-top: 75%;
    }
    p {
      @include r(font-size, 18);
    }
  }

  &.layout-row {
    &.hook-vh {
      .empty-box {
        width: get_vh(400);
      }
      .icon {
        width: get_vh(400);
        height: get_vh(300);
      }
      p {
        @include r(font-size, 24);
      }
    }
    // 横屏 drawer 场景 (drawer 高度受限, 用 vw 单位和其他 vw 元素对齐, 尺寸也更紧凑)
    &.hook-vw {
      .empty-box {
        width: get_vw(340);
      }
      .icon {
        width: get_vw(340);
        height: get_vw(230);
      }
      p {
        font-size: get_vw(20);
      }
    }
    &.hook-px {
      .empty-box {
        width: 400px;
      }
      .icon {
        width: 400px;
        height: 300px;
      }
      p {
        font-size: 24px;
      }
    }
  }
}
</style>